export default "__VITE_ASSET__08b28157__"